import { createSelector } from 'reselect';
import { prop } from 'ramda';

export const selectSnackbarDomain = prop('snackbar');

export const selectActiveSnackbar = createSelector(
  selectSnackbarDomain,
  prop('activeSnackbar')
);

export const selectEndTimestamp = createSelector(
  selectSnackbarDomain,
  prop('endTimestamp')
);
